








































































import Vue from 'vue';
import config from '@/config/index';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';

import { IEtiqueta } from '@/interfaces/Etiquetas';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { ITipoActividad } from '@/interfaces/TipoActividad';
import { ServicioProxy, HomeFiltros } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import moment, { Duration } from 'moment';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { Validator } from 'vee-validate';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import store from '@/store';
import {
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  CellContextMenuEvent,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
  },
})
export default class ContactosNotificados extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: 0 }) id: number;

  //abstract
  funcionalidad: Funcionalidades = Funcionalidades.Notificaciones;
  permisosActuales: PermisoAccionVm[] = [];

  permisosTotales: PermisoAccionVm[] = [];

  //Variables globales
  dialog: boolean = false;
  loadingService = new LoadingService();

  columnDefsNotificados: Array<ColDef> = [];
  sideBar: any = config.agGridDefaultConfig; //
  localeText: any = config.agGridTextos; //

  contactosRespaldo: any[] = [];
  isNoData: boolean = false;
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  usuarioId: number = store.state.userId;
  filtroMes: string = '';
  filtroAnio: string = '';

  gridApi: GridApi;
  columnApi: ColumnApi;
  agGridUtil: AgGridUtil;
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;
  $snotify: any;

  //AXIOS
  axiosNotificacion: AxiosVue = new AxiosVue(ServicioProxy.Notificacion);

  close() {
    this.dialog = false;
    this.$emit('modalAsociacionEmit', false);
  }

  onGridReadyAlertas(params: any) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  constructor() {
    super();

    this.columnDefsNotificados = [
      {
        headerName: 'Nombre del Contacto',
        field: 'contactoNombre',
        suppressMovable: true,
        lockVisible: true,
        resizable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Lista de Distribución',
        field: 'listaDistribucionText',
        resizable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Notificado Correo Electrónico',
        field: 'notificaEmail',
        resizable: true,
        width: 250,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left', 'padding-left': '90px' },
        cellRenderer: this.createMailIcono,
      },
      {
        headerName: 'Notificado Plataforma',
        field: 'notificaGps',
        resizable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left', 'padding-left': '65px' },
        cellRenderer: this.crearTrackIcono,
      },
      {
        headerName: 'Notificado Navegador',
        field: 'notificaNavegador',
        resizable: true,
        width: 200,
        minWidth: 80,
        lockPinned: true,
        sortable: true,
        cellStyle: { textAlign: 'left', 'padding-left': '65px' },
        cellRenderer: this.crearNavegadorIcono,
      },
    ];
  }

  //////////////////////////////////////
  ///Grilla

  @Watch('show')
  async onPropertyChangedS(value: boolean, oldValue: boolean) {
    this.dialog = value;
    const self = this;

    if (value) {
      this.loadingService.showLoading();
      this.getContactos();
      this.loadingService.hideLoading();
    }
  }

  async getContactos() {
    this.contactosRespaldo = [];
    const res: any = await this.axiosNotificacion.http.get(
      `Notificacion/${this.id}/GetEstadoNotificacion`
    );
    if (res.data.notificaContactoVm) {
      this.contactosRespaldo = res.data.notificaContactoVm;
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  onClickCell(params: CellContextMenuEvent) {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 1) {
      appBanners[0].remove();
    }
  }

  createMailIcono(params: any) {
    if (!params.data.notificaEmail) {
      return '';
    }
    var eSpan = document.createElement('i');
    eSpan.innerHTML = 'email';
    eSpan.className = 'material-icons';
    eSpan.id = params.data.id;
    eSpan.style.cssText =
      'cursor:default;color:#27488E;font-size: 25px;padding-top:5px;';
    return eSpan;
  }

  crearTrackIcono(params: any) {
    if (!params.data.notificaGps) {
      return '';
    }
    return `<i class="material-icons" id="1356" style="cursor: default; color: rgb(39, 72, 142); font-size: 25px; padding-top: 5px;">notifications</i>`;
  }

  crearNavegadorIcono(params: any) {
    if (!params.data.notificaGps) {
      return '';
    }

    var eSpan = document.createElement('i');
    eSpan.innerHTML = 'language';
    eSpan.className = 'material-icons';
    eSpan.id = params.data.id;
    eSpan.style.cssText =
      'cursor:default;color:#27488E;font-size: 25px;padding-top:5px;';
    return eSpan;
  }
}
